import vCard from "./v-card.vue";
import vCardGroup from "./v-card-group.vue";

export default Vue => {
  Vue.component("v-card", vCard);
  Vue.component("v-card-group", vCardGroup);
};
